import { render } from "./SidebarUser.vue?vue&type=template&id=017c50f2&ts=true"
import script from "./SidebarUser.vue?vue&type=script&lang=ts"
export * from "./SidebarUser.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__